import type { FieldSyncCache } from '@/mobile/sync/fieldSyncCache';

let memoryCache: FieldSyncCache | null = null;

export function peekFieldCacheMemory(): FieldSyncCache | null {
  return memoryCache;
}

export function setFieldCacheMemory(cache: FieldSyncCache | null): void {
  memoryCache = cache;
}

export function clearFieldCacheMemory(): void {
  memoryCache = null;
}
